<!--components\Alineacion\EsImportante.vue-->
<template>
  <section class="flex flex-col pb-10 pt-10 md:pb-0 md:pt-0">
    <PanelTipoBase1 
      :titulo1="Data.titulo1" 

      :imagen1="Data.imagen1"
      :imagenfondo="Data.imagenfondo"
      :textotitulo="Data.textotitulo"
      :objetoDerecho="Data.objetoDerecho"
      :clasetexto="Data.clasetexto" 

      claseimagenfondo="object-cover"

      orden-texto="md:order-2" 
      orden-imagen="md:order-1" 
      color-texto="text-black"
      espaciado="py-0 md:py-0"
      config-imagen="aspect-square object-contain w-[70%] md:w-[70%] transition-transform duration-500 ease-in-out hover:scale-110 cursor-pointer relative"
      config-padding="px-8 md:px-12 pt-16 md:pt-24 pb-12 md:pb-24" 
      contenedor-padre="w-full" 
      clasediv1="p-4 md:p-14"
      contenedor-padre-sub="w-full" 
      contenedor-imagen="flex items-center justify-center p-4 md:p-4" />
  </section>
</template>

<script setup>
import { ref } from 'vue'
import PanelTipoBase1 from '~/components/Paneles/PanelTipoBase1.vue'

const Data = ref({

  parrafos1: [
    'Se sube el auto a un elevador y, con los equipos de medición necesarios, se comprueban los niveles del vehículo. Con estos datos se pueden corregir los desajustes de la dirección. La alineación ajusta los ángulos de las ruedas, manteniéndolas perpendiculares al suelo y paralelas entre sí.'
  ],
  imagenfondo: '/img/alineacion/fondo_gris2.jpg',
  objetoDerecho: [
    {
      clase_custom:"flex-col md:flex-row pl-[1rem] pr-[1rem] md:pl-[0rem] md:pr-[0rem] gap-[2rem] w-full h-auto justify-start items-center",
      parrafos: ['El desgaste disparejo de los neumáticos es una clara señal de que es necesario realizar este servicio.',
      'También es un indicador cuando notamos que se presenta una fuerte vibración en el volante. En este caso, es necesaria una alineación de las ruedas del eje delantero. Por otro lado, si estamos conduciendo en línea recta y notamos que el manubrio no está completamente centrado y tiende a cargarse hacia la derecha o la izquierda, quiere decir que un eje no está bien alineado.'],
      imagen: '/img/alineacion/Ellipse1.png',
      textotitulo: '¿Cómo puedo saber si mi auto necesita una alineación?',
      clasetexto: 'text-justify md:text-left text-base',
      clasetitulo: 'text-center md:text-left font-bold text-xl mb-2',
    },
    {
      clase_custom:"flex-col md:flex-row-reverse pl-[1rem] pr-[1rem] md:pl-[0rem] md:pr-[0rem] gap-[2rem] w-full h-auto justify-start items-center",
      parrafos: ['Que un auto se desalinee es el resultado normal de la conducción diaria. Las continuas inercias a las que se someten los neumáticos de un vehículo, su suspensión y demás componentes pueden terminar desajustando algún parámetro.',
        'Además, la desalineación también puede acelerarse con un pequeño accidente, al pasar por un bache grande o sufrir un golpe. Esto puede afectar a la suspensión, variando la calibración de algunos de los componentes clave. El resultado son unas ruedas que quedan montadas en ángulos incorrectos.',
        'También puede ocurrir cuando cambiamos alguna pieza relacionada con la dirección, ya que se modifican las cotas de alineado. Por eso es recomendable realizar una alineación cuando sustituimos los neumáticos.'
      ],
      imagen: '/img/alineacion/Ellipse2.png',
      textotitulo: '¿Cuándo y cómo se desalinean las ruedas?',
      clasetexto: 'text-justify md:text-left text-base',
      clasetitulo: 'text-center md:text-left font-bold text-xl mb-2',
      
    },
  ]
})
</script>